import React, {FC} from 'react';

import {LegacyMessageMoreDropdownEntryPointInstance} from '../../../helpers/models/legacyApplicationHelpers';
import {MessageModel} from '../../../models/api/messageModel';
import {NewPanelId} from '../../../store/panels/panelStateBase';
import {LegacyMessageApplicationContextHost} from './legacyMessageApplicationContextHost';

/*
 * Props.
 */

interface LegacyMessageApplicationContextInstanceHostProps {
  panelId: NewPanelId;
  entryPointInstance: LegacyMessageMoreDropdownEntryPointInstance;
  message: MessageModel;
}

/*
 * Component.
 */

export const LegacyMessageApplicationContextInstanceHost: FC<
  LegacyMessageApplicationContextInstanceHostProps
> = (props) => {
  const {panelId, entryPointInstance, message} = props;
  return (
    <LegacyMessageApplicationContextHost
      panelId={panelId}
      key={entryPointInstance.id}
      entryPoint={entryPointInstance.entryPoint}
      message={message}
    />
  );
};
